// Accessible names for icon-only social links ("MyOps on LinkedIn").
const NAMES = {
  facebook: "Facebook",
  github: "GitHub",
  instagram: "Instagram",
  linkedin: "LinkedIn",
  twitter: "X (Twitter)",
  x: "X",
  youtube: "YouTube",
};

export const socialLabel = (social) => `MyOps on ${NAMES[social] || social}`;

export default socialLabel;
